export class MaterialCaptchaRow {
    /**
     * @type {string} format
     */
    public format: string;

    /**
     * @type {string} value
     */
    public value: number;

    /**
     * @type {string} data
     */
    public data: string;

    public constructor(args: any) {
        this.format = args.format;
        this.value = args.value;
        this.data = args.data;
    }
}
